import axios from "@/lib/axios";
import { yearMonthDay } from "@/plugins/moment";

export default {
  namespaced: true,
  state: {
    vendors: [],
    orgs: [],
    allOrgsDetails: [],
    currentOrg: {
      details: {
        paymentWithoutCc: false,
      },
      availableCards: [],
      dosingDetails: {
        enabled: false,
        freeDoses: 0,
        maxDoses: -1,
        numDosingUsers: 0,
        pricePerDose: 39.99,
        paymentMethodId: "",
        billingGracePeriod: 30,
      },
      subscription: {
        nextBillDue: "",
        planId: null,
        planPrice: "",
        billingPeriod: "",
        billingPeriodType: "",
        features: [],
      },
    },
    orgManagementPage: 1,
    orgManagementPageLength: 25,
  },

  getters: {
    getAllVendors: state => {
      return state.vendors;
    },
    getAllOrgs: state => {
      return state.orgs;
    },
    getAdminAllOrgDetails: state => {
      return state.allOrgsDetails;
    },
    getCurrentAdminOrg: state => {
      return state.currentOrg.details;
    },
    getCurrentAdminOrgCards: state => {
      return state.currentOrg.availableCards;
    },
    getCurrentAdminOrgSubscription: state => {
      return state.currentOrg.subscription;
    },
    getCurrentAdminOrgDosingDetails: state => {
      return state.currentOrg.dosingDetails;
    },
    getNumberOfPages(state, getters) {
      const pages = Math.ceil(getters.getAdminAllOrgDetails.length / getters.getPageLength);
      if (pages === 0) {
        return 1;
      }
      return pages;
    },
    getPageLength(state) {
      return state.orgManagementPageLength;
    },
    getPage(state) {
      return state.orgManagementPage;
    },
    getPageResults(state, getters) {
      const page = getters.getPage;
      const results = getters.getAdminAllOrgDetails;
      const pageLength = getters.getPageLength;

      const a = page * pageLength - pageLength;
      const b = a + pageLength;

      return results.slice(a, b);
    },
  },

  mutations: {
    setOrgPage(state, payload) {
      state.orgManagementPage = payload;
    },
    setAdminVendors(state, payload) {
      state.vendors = payload;
    },
    setAdminOrgs(state, payload) {
      state.orgs = payload;
    },
    setAdminOrgDetails(state, payload) {
      state.currentOrg.details = payload;
    },
    setCurrentAdminOrgSubscription: (state, payload) => {
      state.currentOrg.subscription = payload;
    },
    setCurrentAdminOrgCards: (state, payload) => {
      state.currentOrg.availableCards = payload;
    },
    setCurrentAdminOrgDosingDetails: (state, payload) => {
      if (payload) {
        state.currentOrg.dosingDetails = payload;
        state.currentOrg.dosingDetails.enabled = true;
      } else {
        state.currentOrg.dosingDetails = {
          enabled: false,
          freeDoses: 0,
          maxDoses: -1,
          numDosingUsers: 0,
          pricePerDose: 39.99,
          paymentMethodId: "",
          billingGracePeriod: 30,
        };
      }
    },
  },
  actions: {
    nextPage({ getters, commit }) {
      commit("setOrgPage", getters.getPage + 1);
    },
    prevPage({ getters, commit }) {
      commit("setOrgPage", getters.getPage - 1);
    },
    commitPage({ commit }, payload) {
      commit("setOrgPage", payload);
    },
    adminFetchAllVendors: async ({ commit }) => {
      const response = await axios.get("/accounts/v1/vendor");
      commit("setAdminVendors", response.data);
    },
    adminFetchAllOrgs: async ({ commit }) => {
      const response = await axios.get("/accounts/v1/org");
      commit("setAdminOrgs", response.data);
    },
    adminFetchOrgDetails: async ({ commit }, orgId) => {
      const response = await axios.get(`/accounts/v1/org/${localStorage.orgId ? localStorage.orgId : orgId}`);

      commit("setAdminOrgDetails", response.data);
      commit("setCurrentAdminOrgDosingDetails", response.data.dosing);

      return response.data;
    },
    adminFetchAllOrgCardAccounts: async ({ commit, getters }, orgId) => {
      const orgIdVal = orgId || getters.getCurrentAdminOrg.id;
      const response = await axios.get(`/payments/v1/card/buyer/${orgIdVal}/method`);
      commit("setCurrentAdminOrgCards", response.data);
      return response.data;
    },
    updateCurrentOrgSubscription: async ({ commit, getters }) => {
      const orgId = getters.getCurrentAdminOrg.id;
      const currentSub = getters.getCurrentAdminOrgSubscription;
      currentSub.nextBillDue = yearMonthDay(currentSub.nextBillDue);
      const response = await axios.put(`/subscription/v1/admin/organization/${orgId}/subscription`, currentSub);
      commit("setCurrentAdminOrgSubscription", response.data);
    },
    refundFulfillment: async ({ commit }, payload) => {
      const { vendorId, fulfillmentId } = payload;
      const body = {
        refundAmount: payload.refundAmount,
      };
      return axios.post(`/orders/v1/vendor/${vendorId}/fulfillment/${fulfillmentId}/refund`, body);
    },
  },
};
